import PropTypes from 'prop-types';
import cssVars from 'src/common/styles/variables';

/* eslint-disable max-len */
const ArrowRight = ({
  width,
  height,
  viewBox,
  onClick,
  className,
  dataTestId,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox || '0 0 21 21'}
    fill={cssVars['--secondary-color-5']}
    className={className}
    data-testid={dataTestId}
    onClick={onClick}
  >
    <g id="arrow_right" transform="translate(0 23) rotate(-90)">
      <path
        id="Down-Arrow"
        d="M16.688,12.913a.672.672,0,0,0-.949,0l-1.98,1.98V5.671A.671.671,0,0,0,13.088,5H11.745a.671.671,0,0,0-.671.671v9.222l-1.98-1.98a.672.672,0,0,0-.949,0l-.949.949a.672.672,0,0,0,0,.949l3.8,3.8.949.949a.672.672,0,0,0,.949,0l.95-.949,3.8-3.8a.672.672,0,0,0,0-.949Z"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

ArrowRight.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
};

export default ArrowRight;
